import React from "react";

export default function BlockCard({ title, description, buttonText, onClick, disabled }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border p-5">
      <div className="flex items-center justify-between mb-2">
        <div className="font-bold text-gray-900">{title}</div>
        <button
          onClick={onClick}
          disabled={disabled}
          className="px-3 py-2 rounded-lg bg-blue-50 text-blue-700 text-sm hover:bg-blue-100 disabled:opacity-50"
        >
          {buttonText}
        </button>
      </div>
      <div className="text-xs text-gray-500">{description}</div>
    </div>
  );
}